import { Box, Typography, Input, Divider, Card, CardContent, Grid, Checkbox, Chip } from "@mui/joy";
import { KeyboardBackspaceRounded, ImportExportRounded, ShareRounded } from "@mui/icons-material";

import { Factory, Ruler, Search, Split } from "lucide-react";
import { Link } from "react-router-dom";

interface IMaterials {
    item: any;
}
export function Materials(props: IMaterials) {
    const { item } = { ...props };
    return (
        <Box mx={3} mt={2} flex={1}>
            <Box display={"flex"} alignItems={"center"} gap={4}>
                <Box flexShrink={0}>
                    <Link to={"/"}>
                        <Typography level="body-sm" startDecorator={<KeyboardBackspaceRounded />} gutterBottom>
                            Back to Dashboard
                        </Typography>
                    </Link>
                    <Typography level="h4">Materials & Inventory</Typography>
                </Box>
                <Divider orientation="vertical" />
                <Box flex={1}>
                    <Input
                        startDecorator={<Search size={18} />}
                        variant="soft"
                        placeholder="Search or type a command"
                        sx={{ flex: 1 }}
                    />
                </Box>
            </Box>
            <Divider sx={{ mt: 2 }} />
            <Box mt={2}>
                <Typography level="title-md">
                    {item.name} ({item.availableItems})
                </Typography>
                <Typography level="body-sm" gutterBottom>
                    {item.description}
                </Typography>

                <Box mt={4} display="flex" flexWrap="wrap" gap={1}>
                    {item.subcategories?.map((subCategory: string, index: number) => (
                        <Chip
                            key={index}
                            size="sm"
                            variant="outlined"
                            sx={{
                                fontSize: "0.8rem",
                                backgroundColor: "#F4F6F8",
                                color: "#3A3A3A",
                                borderRadius: 6,
                                px: 1.5,
                                py: 0.5,
                                fontWeight: 500,
                            }}
                        >
                            {subCategory}
                        </Chip>
                    ))}
                </Box>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    {item?.sampleItems?.map((e: any, index: number) => {
                        return <MaterialCard key={index} {...e} />;
                    })}
                </Grid>
            </Box>
        </Box>
    );
}

function MaterialCard(props: any) {
    const { name, description, size, unitPrice, brand, seller }: any = { ...props };
    return (
        <Grid xs={12} md={3}>
            <Card variant="soft" sx={{ border: "1px solid", borderColor: "divider" }}>
                <CardContent>
                    <Box>
                        <Box display={"flex"} justifyContent={"space-between"}>
                            <Typography level="title-sm" gutterBottom>
                                {name}
                            </Typography>
                            <Checkbox variant="outlined" />
                        </Box>
                        <Typography level="body-sm" gutterBottom>
                            {description}
                        </Typography>
                        <Typography level="body-sm" startDecorator={<Ruler size={13} />}>
                            {size}
                        </Typography>

                        <Divider sx={{ my: 1.5 }} />

                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                            <Box>
                                <Typography
                                    level="body-sm"
                                    sx={{ fontWeight: 500 }}
                                    gutterBottom
                                    startDecorator={<Factory size={13} />}
                                >
                                    {brand}
                                </Typography>
                                <Typography
                                    level="body-sm"
                                    sx={{ fontWeight: 500 }}
                                    startDecorator={<Split size={13} />}
                                >
                                    {seller}
                                </Typography>
                            </Box>
                            <Typography level="title-md">${unitPrice}</Typography>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    );
}
